<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path
      d="m19 19v-14c0-1.1-.9-2-2-2h-10c-1.1 0-2 .9-2 2v14h-2v2h18v-2zm-2 0h-10v-14h10zm-4-8h2v2h-2z"
    />
  </svg>
</template>
